import Entity from './entity'
export default class PickWave extends Entity<number>{
    code : string;
    note : string;
    status : string;
    refTypeCode : string;
    creationTime : Date
    creatorUserId : number;
    creatorUserName : string;
    refTypeName : string;
}